import { APITypesV1 } from "@cur8/api-client";
import { paths } from "render/routes/paths";

export type SkinScannerRouting = {
  patientId: string;
  visitId: string;
  bloodWorkMode: APITypesV1.BloodWorkMode | undefined;
  bloodWorkAlreadyComplete: boolean;
  showBloodDrawStep: boolean;
};

export function nextDestinationAfterSkinScanner(
  routing: SkinScannerRouting
): string {
  const { patientId, visitId, showBloodDrawStep } = routing;

  if (needsVialAssignment(routing)) {
    return paths.assignVials.url({ patientId, visitId });
  }
  if (showBloodDrawStep) {
    return paths.drawConfirmationStep.url({ patientId, visitId });
  }
  return paths.checkInSuccess.url({ patientId, visitId });
}

// LimsManaged samples and BarcodeAssignment are separate models, so vial
// assignment taking the slot should never be what hides the blood draw step.
// Nothing enforces that, so the caller reports it if it ever happens.
export function bloodModelsCompete(routing: SkinScannerRouting): boolean {
  return needsVialAssignment(routing) && routing.showBloodDrawStep;
}

function needsVialAssignment({
  bloodWorkMode,
  bloodWorkAlreadyComplete,
}: SkinScannerRouting): boolean {
  return (
    bloodWorkMode === APITypesV1.BloodWorkMode.BarcodeAssignment &&
    !bloodWorkAlreadyComplete
  );
}
